/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Timeline/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import AppointmentHistory from 'DesignSystem/AppointmentHistory/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Timeline({
  children,
  viewPath = "/DesignSystem/PatientInformation/Content/AppointmentBooking/Content/AppointmentHistory/Timeline"
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtColorsNeutral100 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.100'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
let patientBookingAppointmentIdValueData = fromData.useDataValue({ viewPath,
context: 'patient',
path: 'booking.appointment._id',
})
  return (<React.Fragment
>
<div
  data-testid="Timeline.Vertical"
  data-view-path={viewPath}
 style={{'--btlr-1-Z2njcxS': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btrr-2-Z2njcxS': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bblr-3-Z2njcxS': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bbrr-4-Z2njcxS': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pt-5-Z2njcxS': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pr-6-Z2njcxS': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pb-7-Z2njcxS': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pl-8-Z2njcxS': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bc-9-Z2njcxS': dtColorsWhite,'--bc-10-Z2njcxS': dtColorsNeutral100}}
 className={`views-block new-shadow ${styles.Vertical}`}
>
<div
  data-testid="Timeline.Vertical:1"
  data-view-path={viewPath}
 style={{'--g-11-Z2njcxS': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--ml-12-Z2njcxS': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Vertical1}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Appointment History"
 color={dtColorsNeutral400}
 weight="medium"
 size="normal"
/>
<AppointmentHistory
  viewPath={`${viewPath}/AppointmentHistory`}
 data="patient.booking.appointment._id"
 appointment_id={patientBookingAppointmentIdValueData}
/>
</div>
</div>
{children}
</React.Fragment>)
}